// GENERATED FILE — DO NOT EDIT.
// Source: cyberfind-strategy analytics/event-registry.json
// Regenerate: node analytics/generate-registry.mjs --out <path>
export const CANONICAL_SHA = '7d6c45a'
export const REGISTRY_VERSION = '1.2.1'

export const EVENT_NAMES = [
  'auth:logged_in',
  'auth:signed_up',
  'invite:accepted',
  'stories:list_viewed',
  'story:opened',
  'search:performed',
  'regulatory:watch_added',
  'vendor:tracked',
  'regulatory:framework_viewed',
  'regulatory:calendar_viewed',
  'regulatory:compare_used',
  'benchmark:viewed',
  'provider:viewed',
  'map:viewed',
  'analytics:tab_viewed',
  'briefing:email_clicked',
  'xproduct:link_followed',
  'catalog:viewed',
  'vendor:profile_viewed',
  'vendor:compared',
  'find:started',
  'find:results_viewed',
  'concierge:apply_started',
  'concierge:apply_submitted',
  'concierge:outcome_captured',
  'review:submitted',
  'trust:page_viewed',
] as const

export type EventName = (typeof EVENT_NAMES)[number]

export interface EventProperties {
  'auth:logged_in': { idp: string }
  'auth:signed_up': { idp: string; invite_source: string }
  'invite:accepted': { invite_age_days: number }
  'stories:list_viewed': { filter_count: number; source_tier_filter?: string }
  'story:opened': { item_source_tier: string; item_age_hours: number }
  'search:performed': { search_term_length: number; results_count: number }
  'regulatory:watch_added': { framework_slug: string }
  'vendor:tracked': { vendor_slug: string }
  'regulatory:framework_viewed': { framework_slug: string }
  'regulatory:calendar_viewed': { window: '30' | '90' | '365' | 'all'; window_days?: number }
  'regulatory:compare_used': Record<string, never>
  'benchmark:viewed': { benchmark_id: string }
  'provider:viewed': { provider_slug: string }
  'map:viewed': { time_window_days: number }
  'analytics:tab_viewed': { analytics_tab: 'decide' | 'trends' | 'compare' }
  'briefing:email_clicked': { briefing_date_offset: number }
  'xproduct:link_followed': { target_product: 'cyberfind-io' | 'community'; surface: 'cross_app_nav' }
  'catalog:viewed': { filters_used: number }
  'vendor:profile_viewed': { has_reviews: boolean }
  'vendor:compared': { vendors_compared_count: number }
  'find:started': Record<string, never>
  'find:results_viewed': { results_count: number; criteria_count: number }
  'concierge:apply_started': { entry_state: 'signed_out' | 'eligible' | 'already_applied' }
  'concierge:apply_submitted': Record<string, never>
  'concierge:outcome_captured': { metrics_provided_count: number }
  'review:submitted': { rating_bucket: string }
  'trust:page_viewed': { surface: 'trust' | 'who_pays_us' }
}

export const BUCKETS = {"search_term_length":[0,5,10,20,50],"results_count":[0,1,5,20,100],"item_age_hours":[0,6,24,72,168],"invite_age_days":[0,1,7,30],"briefing_date_offset":[0,1,3,7,30]} as const

export const ENVELOPE_VALUES = {"product":["intelhub","cyberfind-io","cyberfind-admin"],"env":["prod","dev"],"user_role":["ciso","operator","anon"]} as const

export const REPLAY_POLICY = {"intelhub":{"router":"apps/web/src/App.tsx","recordable":["/","/dashboard","/vulnerabilities","/vulnerabilities/:id","/threat-actors","/threat-actors/:id","/threats/leak-sites","/threats/supply-chain","/providers","/providers/:slug","/map","/analytics","/benchmarks","/benchmarks/:id","/regulatory","/regulatory/frameworks/:slug","/regulatory/calendar","/regulatory/compare","/regulatory-actions","/stories","/stories/:id","/articles","/settings","/trust"],"excluded":["/admin","/admin/content","/admin/sources","/admin/ai/providers","/admin/ai/tasks","/admin/ai/costs","/admin/email","/admin/vendors","/admin/vendors/new","/admin/system","/admin/observability","/admin/stories","/admin/stories/:id","/admin/legal-content","/admin/audit","/admin/analytics","/admin/benchmarks","/admin/benchmarks/new","/admin/benchmarks/pending","/admin/benchmarks/:id/edit","/admin/vulnerabilities","/admin/vulnerabilities/:id/edit","/admin/frameworks","/admin/regulatory-briefs","/admin/regulatory-briefs/:id/edit","/admin/regulatory-deadlines","/admin/regulatory-deadlines/new","/admin/regulatory/digest-runs","/admin/db/perf","/admin/cpe-mappings","/admin/ransomware-groups","/admin/country-overrides","/admin/research-review","/login","/invite","/privacy","/terms","/*"]},"cyberfind-io":{"router":"apps/web/src/routes.tsx","recordable":["/","/how-it-works","/principles","/trust","/who-pays-us","/browse","/vendors/:slug","/profile","/concierge/apply","/find","/find/results","/reviews/new","/reviews/my","/reviews/:id/edit","/compare","/demo-requests","/demo-requests/:id","/settings/notifications"],"excluded":["/privacy","/terms","/admin","/admin/concierge","/admin/concierge/:publicId","/admin/ontology","/concierge/outcome/:token","/*"]},"cyberfind-v2-admin":{"router":"apps/admin/src/App.tsx","recordable":[],"excluded":["/","/welcome","/cisos","/cisos/:id","/vendors","/vendors/new","/vendors/:id/edit","/vendor-claims","/vendor-claims/:id","/reviews","/reviews/:id","/demo-requests","/demo-requests/:id","/email-templates","/email-templates/new","/email-templates/:id","/email-log","/admins","/feature-flags","/audit-log","/concierge","/concierge/:publicId","/pipeline","/review-sources","/review-sources/:id/edit","/disputes","/discoveries","/ai-config"]},"cyberfind-v2-vendor":{"router":"apps/vendor/src/App.tsx","recordable":[],"excluded":["/","/claim/:slug","/request-listing","/dashboard","/profile","/reviews","/demo-requests","/demo-requests/:id","/disputes","/*"]}} as const
